export const KEY_TO_MODE = {
  q: 'info',
  f: 'change',
  d: 'remove',
  s: 'add',
  a: 'data',
  Shift: 'multiselect',
}
